import React, { useEffect, useState } from 'react';
import { getSyncSnapshot, subscribeSync } from '../lib/syncEngine';

const TONE = {
  synced: 'border-emerald-800 bg-emerald-950/70 text-emerald-200',
  submitted: 'border-emerald-800 bg-emerald-950/70 text-emerald-200',
  idle: 'border-border bg-zinc-900/80 text-muted-foreground',
  syncing: 'border-primary/40 bg-primary/10 text-primary',
  pending: 'border-amber-800 bg-amber-950/70 text-amber-100',
  offline: 'border-sky-800 bg-sky-950/70 text-sky-100',
  conflict: 'border-amber-600 bg-amber-950/80 text-amber-100',
  error: 'border-red-800 bg-red-950/70 text-red-100',
};

const SyncStatus = ({ agentId, className = '' }) => {
  const [snap, setSnap] = useState(() => getSyncSnapshot(agentId));

  useEffect(() => {
    setSnap(getSyncSnapshot(agentId));
    return subscribeSync((id, next) => {
      if (!agentId || id === agentId) setSnap(next);
    });
  }, [agentId]);

  return (
    <div
      data-testid="sync-status"
      data-sync-state={snap.status}
      className={`inline-flex max-w-full items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-medium ${TONE[snap.status] || TONE.idle} ${className}`}
    >
      <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${snap.status === 'syncing' ? 'animate-pulse bg-current' : 'bg-current'}`} />
      <span className="truncate">{snap.message}</span>
    </div>
  );
};

export default SyncStatus;
